export default __webpack_public_path__ + "static/107-d55129748a585cb9d43b1c39dc340a68.gif";